import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { FontSize, FontType, FontWeight } from '../../../constants/Fonts';
import { MediaQuery } from '../../../constants/Styles';

export const HeaderHomepage = styled.div`
  justify-content: center;
  align-items: center;
  padding: 0 100px;
  margin-bottom: 95px;
  min-height: 300px;

  ${MediaQuery.XL_AND_DOWN} {
    padding: 0 50px;
  }

  ${MediaQuery.L_AND_DOWN} {
    margin-bottom: 60px;
    min-height: initial;
    padding: 0 20px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  width: 100%;
  position: relative;
  margin: auto;
`;

export const Subtitle = styled.h2`
  color: ${Color.DOLPHIN};
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXL};
  font-weight: ${FontWeight.REGULAR};
  margin-bottom: 30px;
  max-width: 670px;
`;

export const TitleDynamicWrapper = styled.span`
  font-size: 54px;
  font-family: ${FontType.PRIMARY};
  font-weight: ${FontWeight.BLACK};
  color: ${Color.CLOUD_BURST};
  margin-bottom: 20px;

  ${MediaQuery.L_AND_DOWN} {
    min-height: 180px;
  }

  ${MediaQuery.M_AND_DOWN} {
    flex-flow: wrap;
    margin-bottom: 10px;
    justify-content: flex-start;
  }

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XXXXXL};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  text-align: center;

  div {
    h1 {
      font-family: ${FontType.PRIMARY};
      font-size: 54px;
      font-weight: ${FontWeight.BLACK};
    }
  }

  ${MediaQuery.L_AND_DOWN} {
    margin: 50px auto 30px auto;
  }

  ${MediaQuery.S_AND_DOWN} {
    margin: 0px auto 0 auto;

    div {
      h1 {
        font-size: ${FontSize.XXXXXL};
      }
    }
  }
`;
